import { ApiCall } from "common/types/api";
import { CancellablePromise } from "common/types/promises";

export const versionApi = (apiCall: ApiCall) => ({
  version: (): CancellablePromise<string> => apiCall("get", `api/version`),
});
